export default setFieldValue => customer => {
  setFieldValue("email", customer?.user?.email || "");
};
